import {Outlet, Navigate} from "react-router-dom";
import {useContext} from "react";
import AuthContext from "../context/AuthContext";
import Loader from "./Loader";


function AuthRoute() {
    // const { status, data } = useAuth()
    // console.log('In private route', data)
    const {accessToken, user, isUserLoading} = useContext(AuthContext)
    let isAuthenticated = accessToken ? true: false
    // let auth = true
    // let auth = {'token': true}

    if (isAuthenticated && isUserLoading) {
        return <div className="d-flex justify-content-center mt-5"><Loader size="default" /></div>
    }

    if (isAuthenticated && !user) {
        return <Outlet/>
    }

    return (
        <>
            {!isAuthenticated ? <Outlet/> : <Navigate to={user?.must_change_password ? '/force-password-change' : '/'} replace />}
        </>
    );
}

export default AuthRoute;
